import axios from "axios";
import React, { useEffect } from "react";
import { useState,useRef } from "react";
import {  toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function ContactForm(){
    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(0);
    const [operator, setOperator] = useState('+');
    const [correctAnswer, setCorrectAnswer] = useState(null);
    const [isBlocked, setIsBlocked] = useState(false);
    const [result, setResult] = useState(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const form = useRef(null);

    const generateQuestion = ()=>{
        const num1 = Math.floor(Math.random() * 10) + 1;
        const num2 = Math.floor(Math.random() * 10) + 1;
        const operators = ['+', '-', '*'];
        const randomOperator = operators[Math.floor(Math.random() * operators.length)];
        let answer = 0;
        switch (randomOperator) {
            case '+':
                answer = num1 + num2;
                
                break;
            case '-':
                answer = num1 - num2;
                
                break;
            case '*':
                answer = num1 * num2;
                
                break;
            default:
                answer = num1 + num2;
                
                break;
        }
        setNum1(num1);
        setNum2(num2);
        setOperator(randomOperator);
        setCorrectAnswer(answer);
    }
    useEffect(()=>{
        generateQuestion();
    },[]);
const HandleForm = (e)=>{
    e.preventDefault();
    if(parseFloat(result) === parseFloat(correctAnswer)){
        toast.success("Correct Answer!");
        SubmitForm(e);
    }
    else{
        toast.error("Incorrect Answer");
    }
}
const SubmitForm= async (event)=>{
  event.preventDefault();

if (!name || !email || !phone || !subject || !message) {
  toast.error("Please fill in all fields.");
  return;
}
if (!/\S+@\S+\.\S+/.test(email)) {
  toast.error("Please enter a valid email address.");
   return;
 }
 toast.info('Sending mail....');
 const formData={
  name: name,
  email: email,
  subject: subject,
  phone: phone,
  message: message
};

 try {
  const response =await axios.post('https://samahomecare.com/api/contact.php', formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  if(response.data.success){
    toast.success("Mail sent successfully");
  }
  else{
    toast.error("Mail not sent");
  }
 } catch (error) {
  toast.error(error.message);
 }
 event.target.reset();
}
return(
    <>
     <section id="Contact-form1">
        <div className="container">
          <form ref={form} method="post" onSubmit={HandleForm} >
            <div className="row">
              <div className="col-md-12" id="Input">
                <label>Name:</label>
                <input
                  type="text"
                  name="from_name" // Matches Email.js Template
                  placeholder="Enter your name"
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12" id="Input">
                <label>Email:</label>
                <input
                  type="email"
                  name="user_email" // Not used in template, but can be added
                  placeholder="Enter your email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12" id="Input">
                <label>Subject:</label>
                <input
                  type="text"
                  name="Subject"
                  placeholder="Enter your subject"
                  onChange={(e) => setSubject(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12" id="Input">
                <label>Phone Number:</label>
                <input
                  type="text"
                  name="Phone_Number"
                  placeholder="Enter your phone number"
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12" id="Input">
                <label>Message:</label>
                <textarea
                  name="message" // Matches Email.js Template
                  placeholder="Enter your message"
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row">
                <div className="col-md-12" id="Input">
                    <label>{num1} {operator} {num2}</label>
                    <input type="text" name="answer" onChange={(e) => setResult(e.target.value)} required placeholder="Enter the correct answer" />
                </div>
            </div>

           
            <div className="row1">
              <div className="col-lg-3 col-md-6 col-sm-12">
                <button type="submit" className="nav0cta1 text-left">Submit</button>
              </div>
            </div>
          </form>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
      </section>
    </>
)
}
export default ContactForm;